import {
	createStore
} from 'vuex'
import {
	ls
} from 'vue-lsp'

import {
	formatterMenu
} from '@/utils/utils'
import {
	login,
	logout
	//getDictTypeTree
} from '@/api/login'
import {
	Get
} from '@/api/Api'
import {
	ACCESS_TOKEN,
	ALL_APPS_MENU,
	DICT_TYPE_TREE_DATA,
	NOTICE_RECEIVED
} from '@/store/mutation-types'
import {
	message
} from 'ant-design-vue'

// import VuexPersistence from 'vuex-persist'

// const vuexLocal = new VuexPersistence({
// 	storage: window.localStorage
// })
/*import UserInfo1 from "./src/store/UserInfo.json";*/
export default createStore({
	state: {
		token: '',
		apps: [],
		menus: [],
		curSystem: '',
		menuList: [],
		tabs: [],
		curSelKey: '',
		userInfo: '',
		openKeys: [],
	},
	mutations: {
		SET_TOKEN: (state, token) => {
			state.token = token
		},
		SET_USERINFO(state, payload) {
			state.userInfo = payload;
		},
		SET_APPS(state, payload) {
			state.apps = payload;
			state.curSystem = payload.find(item => item.active == 'Y').code
		},
		SET_MENUS(state, payload) {
			state.menus = payload;
			const data = state.menus.filter(function(_data) {
				return _data.application.toLowerCase() == state.curSystem.toLowerCase()
			})
			const menu = formatterMenu(data, 'T0')
			state.menuList = menu;
			/*
			state.curSelKey = 'wekcome';
			state.tabs = [{
				"id": "wekcome",
				"component": "index/wekcome",
				"meta": {
					"title": "首页",
					"icon": "",
					"show": true,
					"target": null,
					"link": "",
					"type": "MENU"
				}
			}];
			*/
			// if (menu.length > 0) {
			// 	const obj = menu[0];
			// 	if (obj.children.length > 0) {
			// 		state.curSelKey = obj.children[0].id
			// 		state.tabs = [obj.children[0]];
			// 	} else {
			// 		state.curSelKey = obj.id;
			// 		state.tabs = [obj];
			// 	}
			// }
		},
		addTab(state, payload) {
			const index = state.tabs.findIndex(item => item.id == payload.id)
			if (index == -1) {
				state.tabs.push(payload);
			}
			state.curSelKey = payload.id
		},
		removeTab(state, payload) {
			//debugger
			const tab = state.tabs[payload];
			state.tabs.splice(payload, 1);
			if (state.tabs.length > 0 && tab.id == state.curSelKey) {
				const lastIndex = payload - 1;
				if (lastIndex >= 0) {
					state.curSelKey = state.tabs[lastIndex].id;
				} else {
					state.curSelKey = null;
				}
			}
		},
		closeOther(state, payload) {
			const tab = state.tabs.find(item => item.id == payload.id)
			state.tabs = [tab];
			state.curSelKey = tab.id;
		},
		closeLeft(state, payload) {
			state.tabs.splice(0, payload);
		},
		closeRight(state, payload) {
			state.tabs.splice(payload, state.tabs.length);
		},
		setCurKey(state, payload) {
			console.log(payload)
			state.curSelKey = payload;
		},
		changeSystem(state, payload) {
			message.loading('正在切换应用！', 1);

			if (state.curSystem == payload) return;
			state.curSystem = payload;

			const data = state.menus.filter(function(_data) {
				return _data.application.toLowerCase() == payload.toLowerCase()
			});
			const menu = formatterMenu(data, 'T0')
			state.menuList = menu;


			// if (menu.length > 0) {
			// 	const obj = menu[0];
			// 	if (obj.children.length > 0) {
			// 		state.curSelKey = obj.children[0].id
			// 		state.tabs = [obj.children[0]];
			// 	} else {
			// 		state.curSelKey = obj.id;
			// 		state.tabs = [obj];
			// 	}
			// }
			state.openKeys = []
		},
		setopenKeys(state, payload) {
			state.openKeys = payload ? [payload] : [];
		}
	},
	actions: {
		// 登录
		Login({
			commit
		}, userInfo) {
			return new Promise((resolve, reject) => {
				login(userInfo).then(response => {
					if (!response.succeeded) {
						reject(response.errors)
						return
					}
					console.log(response)
					ls.set(ACCESS_TOKEN, response.data, 7 * 24 * 60 * 60 * 1000)
					commit('SET_TOKEN', response.data)
					resolve()
				}).catch(error => {
					console.log(error)
					reject('后端未启动或代理错误')
				})
			})
		},
		// 获取用户信息
		GetInfo({
			commit
		}) {
			new Promise((resolve, reject) => {
				Get('/api/getLoginUser').then(response => {
					if (!response.succeeded) {
						reject(response.errors)
						return
					}
					console.log(response.data)
					commit('SET_APPS', response.data.apps);
					commit('SET_USERINFO', response.data.user);
					commit('SET_MENUS', response.data.menus);
					resolve(response.data)
				}).catch(error => {
					console.log(error)
					reject('后端未启动或代理错误')
				})
			})
			
		},
		// 登出
		Logout({
			commit,
			state
		}) {
			return new Promise((resolve) => {
				logout(state.token).then(() => {
					resolve()
				}).catch(() => {
					resolve()
				}).finally(() => {
					commit('SET_TOKEN', '')
					ls.remove(ACCESS_TOKEN)
				})
			})
		},

		// 加载所有字典数据
		// DictTypeData() {
		// 	return new Promise((resolve, reject) => {
		// 		getDictTypeTree().then((data) => {
		// 			if (data.success) {
		// 				console.log(data)
		// 				const result = data.data
		// 				//Vue.ls.set(DICT_TYPE_TREE_DATA, result)
		// 				resolve()
		// 			} else {
		// 				// eslint-disable-next-line no-undef
		// 				reject(new Error(data.message))
		// 			}
		// 		}).catch(error => {
		// 			reject(error)
		// 		})
		// 	})
		// }

	},
	modules: {},
	//plugins: [vuexLocal.plugin]
})
